export enum MTabGroupAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export type MTabGroupTab = {
  label: string;
  iconName?: string;
  content?: React.ReactNode;
};

export type MTabGroupProps = {
  alignment?: MTabGroupAlignment;
  numberOfTabs?: number;
  icon?: boolean;
  description?: boolean;
  tabs: MTabGroupTab[];
  className?: string;
};
